import SearchResultPagination from './SearchResultPagination';

export default SearchResultPagination;
